// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"86":"02b2db5b4f82f5e7","98":"528c9be12eb90025"}[chunkId] + ".js";
};